/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ window: NonNullable<unknown> }} Measure_Uptime_MeasuredInputs */

const en_measure_uptime_measured = /** @type {(inputs: Measure_Uptime_MeasuredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window} · measured`)
};

const zh_hans1_measure_uptime_measured = /** @type {(inputs: Measure_Uptime_MeasuredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window} · 实测`)
};

const pt_br2_measure_uptime_measured = /** @type {(inputs: Measure_Uptime_MeasuredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window} · medido`)
};

const es_measure_uptime_measured = /** @type {(inputs: Measure_Uptime_MeasuredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window} · medido`)
};

const fr_measure_uptime_measured = /** @type {(inputs: Measure_Uptime_MeasuredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window} · mesuré`)
};

const de_measure_uptime_measured = /** @type {(inputs: Measure_Uptime_MeasuredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window} · gemessen`)
};

const ru_measure_uptime_measured = /** @type {(inputs: Measure_Uptime_MeasuredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window} · измерено`)
};

const it_measure_uptime_measured = /** @type {(inputs: Measure_Uptime_MeasuredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window} · misurata`)
};

/**
* | output |
* | --- |
* | "{window} · measured" |
*
* @param {Measure_Uptime_MeasuredInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_uptime_measured = /** @type {((inputs: Measure_Uptime_MeasuredInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Uptime_MeasuredInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_uptime_measured(inputs)
	if (locale === "pt-BR") return pt_br2_measure_uptime_measured(inputs)
	if (locale === "es") return es_measure_uptime_measured(inputs)
	if (locale === "fr") return fr_measure_uptime_measured(inputs)
	if (locale === "de") return de_measure_uptime_measured(inputs)
	if (locale === "ru") return ru_measure_uptime_measured(inputs)
	if (locale === "it") return it_measure_uptime_measured(inputs)
	return en_measure_uptime_measured(inputs)
});